import { Spin } from 'antd';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { ColumnDescriptor } from 'Types/TableTypes';

type Props<T> = {
  records: T[];
  loading: boolean;
  loader?: JSX.Element;
  columns: Array<ColumnDescriptor<T>>;
  fetchMore: () => void;
  height?: number | string;
} & typeof defaultProps;

const defaultProps = {
  height: 'auto' as number | string,
  loader: <Spin />,
};

const Wrapper = styled.div`
  .table-header {
    display: flex;
    align-items: center;
  }
  .table-body {
    margin-top: 6px;
    .ant-spin {
      display: flex;
      justify-content: center;
      margin-top: 25px;
      margin-bottom: 25px;
    }
    .table-row {
      display: flex;
      align-items: center;
      margin-top: 8px;
      border-radius: 10px;
      height: 58px;
      box-shadow: 0px 0px 17px -2px #00000015;
      padding: 14px 12px;
      background-color: #fff;
      .table-cell {
        flex: 1;
      }
    }
  }
`;

const TableView = function TableView<T>(props: Props<T>) {
  const {
    loading, records, columns, fetchMore, height, loader,
  } = props;

  return (
    <Wrapper className="table">
      <div className="table-header">
        {columns.map((column) => (
          <div className="table-cell" style={{ flex: column.width ? `0 1 ${column.width}%` : 1 }}>
            {column.headerRenderer()}
          </div>
        ))}
      </div>
      <div className="table-body">
        <InfiniteScroll
          dataLength={records?.length}
          hasMore
          loader={null}
          next={fetchMore}
          height={height}
        >
          {records?.map((record) => (
            <div className="table-row">
              {columns?.map((column) => (
                <div className="table-cell" style={{ flex: column.width ? `0 1 ${column.width}%` : 1 }}>
                  {column.cellRenderer(record[column.id])}
                </div>
              ))}
            </div>
          ))}
          {loading ? loader : null}
        </InfiniteScroll>
      </div>
    </Wrapper>
  );
};

TableView.defaultProps = defaultProps;
export default TableView;
